<template>
    <div v-if="!isLoading">
        <div class="main-content">
            <ShopCart :store="filterStore.store"/>
            <section class="togoback container">
                <div class="content-brand w-100">
                    <GoToBackButton />
                    <div class="content-brand-elements d-none d-lg-block">
                        <router-link tag="a" :to="{ name: 'Home' }" class="content-brand-elements-links">
                            Ínicio
                        </router-link>
                        <span> > </span>
                        <router-link tag="a" :to="{ name: 'PartnerLandingPage',
                            params: { slug: filterStore.store.product.slug } }"
                            class="content-brand-elements-links">
                            {{ filterStore.store.product.name }}
                        </router-link>
                    </div>
                </div>
            </section>
            <SectionSuggestions :categories="categories" :slug="slug" />
            <CategoryStore :categories="filters" :slug="slug"/>
            <MenuCart />
            <section class="partner-content container">
                <div class="togoback bottom">
                    <div class="content-brand w-100 mb-0">
                        <GoToBackButton />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import SectionSuggestions from "../components/SectionSuggestions";
import CategoryStore from "../components/CategoryStore.vue";
import MenuCart from "../components/MenuCart.vue";
import ShopCart from '../components/ShopCart.vue';

export default {
	data() {
		return {
            slug: this.$route.params.slug,
            isLoading: true,
		}
	},
    computed: {
        ...mapGetters({ 
            filters: "Products/productsFilters",
            categories: "Products/families",
            filterStore: "Products/FilterStore/filterList",
        }),
        
    },
	components: {
		CategoryStore,
		MenuCart,
		GoToBackButton,
		SectionSuggestions,
		ShopCart
	},
    methods: {
        loadData() {
            this.$store.dispatch('Products/getFamilies', { slug: this.slug });
            this.$store.dispatch("Products/getProductsFilters", { slug: this.slug });
            this.isLoading = false;
        },
    },

    created() {
        this.$store.dispatch("Products/FilterStore/setFilterList", { slug: this.slug });
    },
    
    watch: {
        filterStore() {
            this.loadData();
        },
    },
}
</script>
<style lang="scss" scoped>
.main-content{
	margin-top: 230px;
	padding-bottom: 50px;
	@media screen and (max-width: 991px){
		margin-top: 260px;
	}
}
.togoback{
    &-btn{
        display: flex;
        background-color: #FFFFFF;
        width: 114px;
        height: 47px;
        margin-right: 1rem;
        border: 1px solid var( --green-medium);
        border-radius: 10px;
        justify-content: center;
        align-items: center;
		&:hover, &:focus{
			transition: all 0.5s ease;
			filter: drop-shadow(0 0 10px var( --green-medium));
		}
        @media screen and (max-width: 768px){
            width: 100px;
            height: 40px;
        }        
        @media screen and (ax-width: 576px){
            width: 70px;
            height: 35px;
            margin-right: 0.5rem;
        }
        @media screen and (max-width: 400px){
            width: 60px;
            height: 40px;
            margin-right: 0.5rem;
        }
        a{
            font-family: 'Font Regular';
            font-size:1.375rem;
            color: var( --green-medium);
            @media screen and (max-width: 768px){
                font-size: 1.125rem;
            }
            @media screen and (max-width: 576px){
                font-size: 0.8rem;
            }
        }
    }
    &-path{
        padding: 0;
        display: flex;
        align-items: center;
        p{
            color: #112D23;
            font-family: 'Font Semibold', sans-serif;
            font-size: 1.563rem;
            margin: 0;
            @media screen and (max-width: 768px){
                font-size: 1rem;
            }
            @media screen and (max-width: 576px){
                font-size: 0.8rem;
                align-items: flex-start;
                text-align: left;
            }
            @media screen and (max-width: 400px){
                font-size: 0.7rem;
            }
        };
        
    }
}
</style>